interface ErrorWithStatus {
  status?: unknown;
  statusCode?: unknown;
  response?: { status?: unknown };
}

/**
 * Reads an HTTP status from an unknown error. Checks `status`, then `statusCode`, then
 * `response.status`. Returns the first value that is a number, else `undefined`.
 */
export function getErrorStatusCode(error: unknown): number | undefined {
  if (typeof error !== "object" || error === null) {
    return undefined;
  }

  const { status, statusCode, response } = error as ErrorWithStatus;
  const candidates = [status, statusCode, response?.status];
  return candidates.find((value): value is number => typeof value === "number");
}
